// extracted by mini-css-extract-plugin
export default {"itemList":"style-module--itemList--Hgiif","icon":"style-module--icon--lAy-3"};